import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { SkuValidationDto } from './types'

export const getPickingRouteProducts = (pickingRouteId: number) => {
  const url = new URL(
    `${ApiConfig.PickingRouteValidationApi}/${pickingRouteId}/validationdetails`
  )

  return axios.get(url.toString())
}

export const validateSku = (
  pickingRouteId: number,
  body: SkuValidationDto[]
) => {
  const url = new URL(
    `${ApiConfig.PickingRouteValidationApi}/${pickingRouteId}/validateSku`
  )

  return axios.patch(url.toString(), body)
}

export const getPickingRouteRelated = (
  pickingRouteId: number,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(
    `${ApiConfig.PickingRouteValidationApi}/GetPickingValidationRelatedRoute`
  )

  url.searchParams.set('pickingRouteId', pickingRouteId.toString())
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  return axios.get(url.toString())
}

export const getValidateIsSingleOrderOT = (pickingRouteId: number) => {
  const url = new URL(
    `${ApiConfig.PickingRouteValidationApi}/ValidateSingleOrderOT/${pickingRouteId}`
  )
  return axios.get(url.toString())
}

export const resetAllValidated = (pickingRouteId: number) => {
  const url = new URL(
    `${ApiConfig.PickingRouteValidationApi}/${pickingRouteId}/resetAllValidated`
  )

  return axios.patch(url.toString())
}

export const resetSkuValidation = (
  pickingRouteId: number,
  body: SkuValidationDto[]
) => {
  const url = new URL(
    `${ApiConfig.PickingRouteValidationApi}/${pickingRouteId}/resetSkuValidation`
  )

  return axios.patch(url.toString(), body)
}
